import React, { useState } from 'react';
import { Button } from '@shared/components/ui/button';
import { Input } from '@shared/components/ui/input';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { cn } from '@shared/utils/utils';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name?: string;
  classNameWrapper?: string;
  classNameInput?: string;
}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ label, name, classNameWrapper, classNameInput, ...props }, ref) => {
    const [show, setShow] = useState(false);

    return (
      <div className={cn(classNameWrapper)}>
        {label && (
          <label htmlFor={name} className="block text-sm font-medium mb-1">
            {label}
          </label>
        )}
        <div className="relative">
          <Input
            ref={ref}
            name={name}
            id={name}
            type={show ? 'text' : 'password'}
            className={cn('pr-10', classNameInput)}
            {...props}
          />
          <Button
            type="button"
            variant="ghost"
            icon={show ? faEyeSlash : faEye}
            onClick={() => setShow((s) => !s)}
            className="absolute right-2 top-[8px] h-6 w-6 p-0 opacity-25"
            iconPosition="start"
            name={`${name}-toggle`}
          />
        </div>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
